/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 用户助力信息
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  activityQuery: cms.activityQuery,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<cms.ActivityUserHelpDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/cms/findActivityHelpInfo`,
    data: activityQuery,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
